<div *ngFor="let attribute of attributes">
  <ng-container [ngSwitch]="attribute.type">
    <attribute-string *ngSwitchCase="'STRING'" [attribute]="attribute" [form]="form"></attribute-string>
    <attribute-enum *ngSwitchCase="'ENUM'" [attribute]="attribute" [form]="form"></attribute-enum>
    <attribute-date *ngSwitchCase="'DATE'" [attribute]="attribute" [form]="form"></attribute-date>
    <attribute-boolean *ngSwitchCase="'BOOLEAN'" [attribute]="attribute" [form]="form"></attribute-boolean>
    <attribute-agreement *ngSwitchCase="'AGREEMENT'" [attribute]="attribute" [form]="form"></attribute-agreement>
  </ng-container>
</div>
